import React from 'react'
import { useCustomAlert } from './useCustomAlert';
import { Alert } from '@mui/material';

export const CustomAlert = () => {
    const {alert, closeAlert} = useCustomAlert();
  return (
    <>
     {alert && (
          <Alert severity={alert.severity} onClose={closeAlert} variant="filled">
            {alert.message}
          </Alert>
        )}
    
    </>
  )
}
